// extracted by mini-css-extract-plugin
export default {"cascadedProfileContainer":"DualProfile__cascadedProfileContainer___PYOqR","cascadedProfile":"DualProfile__cascadedProfile___NKhKT"};